<template>
  <div
    class="relative flex-1"
    :class="{
      'level-card-ring rounded-[22px] p-0.5': isActive,
      [`border-background-neutral-onblock rounded-[20px] border-2 ${levelBgClass}`]:
        !isActive,
    }"
  >
    <div
      class="relative flex h-full flex-col items-center gap-2 py-3"
      :class="{
        [`bg-background-neutral-secondary rounded-[20px] ${levelBgClass}`]:
          isActive,
      }"
    >
      <div
        v-if="isActive"
        class="badge-current-level text-2xs absolute -bottom-1.5 left-1/2 -translate-x-1/2 rounded-[20px] px-1.5 py-0.5 font-medium whitespace-nowrap text-white"
      >
        {{ t('cashbackInfo.current-level') }}
      </div>
      <img
        :src="level.icon"
        width="32"
        height="32"
        alt=""
        class="icon-shadow rounded-full"
      />
      <div class="flex flex-col items-center text-center">
        <span class="freedom-loyalty-text inline-block text-base font-bold">
          {{ level.cashback }}%
        </span>
        <span class="text-text-neutral-primary text-xs font-medium opacity-90">
          {{ level.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import type { CashbackLevel } from '../types';
  import messages from '../locales.json';

  const props = defineProps<{
    level: CashbackLevel;
    isActive: boolean;
  }>();

  const { t } = useI18n({ messages });

  const levelBgClass = computed(
    () => `level-bg-${props.level.name.toLowerCase()}`,
  );
</script>

<style scoped>
  .level-bg-standard {
    background-image: linear-gradient(
      143deg,
      rgb(var(--background-neutral-secondary) / 0.4) 0%,
      rgba(122, 172, 160, 0.4) 100%
    );
  }
  .level-bg-silver {
    background-image: linear-gradient(
      143deg,
      rgb(var(--background-neutral-secondary) / 0.4) 0%,
      rgba(141, 158, 188, 0.4) 100%
    );
  }
  .level-bg-gold {
    background-image: linear-gradient(
      -63deg,
      rgba(200, 190, 137, 0.4) 0%,
      rgb(var(--background-neutral-secondary) / 0.4) 100%
    );
  }
  .level-bg-platinum {
    background-image: linear-gradient(
      -38deg,
      rgba(71, 100, 169, 0.3) 0%,
      rgb(var(--background-neutral-secondary) / 0.3) 100%
    );
  }

  .level-card-ring {
    background: linear-gradient(to bottom right, #036bb9, #00c57f);
  }

  .badge-current-level {
    background-image: linear-gradient(245deg, #00c57f 0%, #036bb9 100%);
  }

  .icon-shadow {
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.05);
  }
</style>
